<div class="close-container close-icon" (click)="onNoClick()">
    <i class="material-icons ">close</i>
</div>

<h1 mat-dialog-title class="title-dialog">{{info.title}}</h1>
<div mat-dialog-content>
    <p class="content-message"> {{info.message}}</p>

</div>
<div mat-dialog-actions class="buttons-container">
    <div class="content-btn">
        <button class="action-button" (click)="onNoClick()"> {{"BUTTON.CANCEL" | translate}} </button>
    </div>
    <div class="content-btn primary">
        <button class="action-button" (click)="confirmClick()"> {{"BUTTON.CONFIRM" | translate}} </button>
    </div>
</div>